import { SimplePropertyModel } from '../../swagger/putujmoAdminService';

export const getSimplePropertyDisplayName = (property: SimplePropertyModel): string => {
	if (!property.content) return property.propertyId;
	try {
		const parsed = JSON.parse(property.content);
		const name = parsed?.name || parsed?.Name || parsed?.title || parsed?.Title;
		const city = parsed?.city || parsed?.City;
		const label = [name, city].filter(Boolean).join(' - ');
		return label || property.propertyId;
	} catch {
		return property.propertyId;
	}
};
